export const mapOrder = (array, order, key) => array.sort((a, b) => (order.indexOf(a[key]) > order.indexOf(b[key]) ? 1 : -1));

export const groupBy = (list, keyGetter) => {
  const map = new Map();
  list.map(item => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });

  return map;
};
